function _typeof(o) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, _typeof(o);
}
function _classCallCheck(a, n) {
    if (!(a instanceof n))
        throw new TypeError('Cannot call a class as a function');
}
function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, 'string');
    return 'symbol' == _typeof(i) ? i : i + '';
}
function _toPrimitive(t, r) {
    if ('object' != _typeof(t) || !t)
        return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != _typeof(i))
            return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return ('string' === r ? String : Number)(t);
}
import handleOption from './options';
import createPlayer from './template';
import bindEvents from './events';
import utils from './utils';
var SPlayer = function () {
    function SPlayer(options) {
        _classCallCheck(this, SPlayer);
        this.options = handleOption(options);
        this.container = this.options.container;
        this.original = this.options.options;
        this.info = this.options.audio;
        createPlayer({
            container: this.container,
            options: this.original,
            audio: this.info
        });
        bindEvents({
            container: this.container,
            volume: this.original.volume
        });
    }
    return _createClass(SPlayer, [
        {
            key: 'audio',
            get: function get() {
                return this.container.querySelector('.splayer-audio');
            }
        },
        {
            key: 'play',
            value: function play() {
                this.audio.play();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.audio.pause();
            }
        },
        {
            key: 'seek',
            value: function seek(time) {
                this.audio.currentTime = time;
            }
        },
        {
            key: 'volume',
            value: function volume(percentage) {
                this.audio.volume = percentage;
            }
        },
        {
            key: 'on',
            value: function on(event, handler) {
                this.audio.addEventListener(event, handler);
            }
        }
    ]);
}();
export default SPlayer;
utils.setupAudioMutex();